import { ENDPOINTS, IS_MAINNET, IS_TESTNET } from '@shared/utils/constant'

const NINJA_PASS_ENDPOINT: string =
  import.meta.env.VITE_NINJA_PASS_ENDPOINT ||
  'https://api.ninjapass.injective.dev'

const ARCHIVER_ENDPOINT = IS_MAINNET
  ? 'https://archiver-rfq.grpc-web.mainnet.asia.injective.network'
  : IS_TESTNET
    ? 'https://archiver-rfq.grpc-web.testnet.us.injective.network'
    : 'https://devnet.archiver-rfq.injective.dev'

export const WS_PRICE_ORACLE_ENDPOINT =
  import.meta.env.VITE_WS_PRICE_ORACLE_ENDPOINT ||
  (IS_MAINNET
    ? 'https://ws-price-oracle.injective.network/'
    : 'https://testnet.ws-price-oracle.injective.network/')

export const FAUCET_ENDPOINT = IS_TESTNET
  ? import.meta.env.VITE_FAUCET_TESTNET_API
  : import.meta.env.VITE_FAUCET_MAINNET_API

const TC_DERIVATIVES_ENDPOINT = IS_MAINNET
  ? 'https://tc-derivatives.grpc-web.mainnet.asia.injective.network'
  : IS_TESTNET
    ? 'https://testnet.tc-derivatives.injective.network'
    : ENDPOINTS.indexer

const RFQ_GATEWAY_ENDPOINT = IS_MAINNET
  ? 'https://rfq.gateway.grpc-web.injective.network/'
  : IS_TESTNET
    ? 'https://testnet.rfq.gateway.injective.network/'
    : ENDPOINTS.indexer

const RFQ_ENDPOINT = IS_MAINNET
  ? 'https://rfq.grpc-web.injective.network/'
  : IS_TESTNET
    ? 'https://testnet.rfq.injective.network/'
    : ENDPOINTS.indexer

const TC_ABACUS_ENDPOINT = IS_MAINNET
  ? 'https://tc-abacus.grpc-web.mainnet.asia.injective.network/grpc'
  : IS_TESTNET
    ? 'https://testnet.tc-abacus.injective.network/grpc'
    : 'https://devnet.api.injective.dev/grpc'

const CIRCLE_API_ENDPOINT = IS_TESTNET
  ? 'https://iris-api-sandbox.circle.com'
  : 'https://iris-api.circle.com'

export const TC_ENDPOINTS = {
  rfq: RFQ_ENDPOINT,
  faucet: FAUCET_ENDPOINT,
  archiver: ARCHIVER_ENDPOINT,
  tcAbacus: TC_ABACUS_ENDPOINT,
  ninjaPass: NINJA_PASS_ENDPOINT,
  rfqGateway: RFQ_GATEWAY_ENDPOINT,
  tcDerivatives: TC_DERIVATIVES_ENDPOINT,
  wsPriceOracle: WS_PRICE_ORACLE_ENDPOINT,
  circleApi: CIRCLE_API_ENDPOINT
}

export const MIXPANEL_KEY = import.meta.env.VITE_MIXPANEL_KEY || ''
export const FEE_RECIPIENT = import.meta.env.VITE_FEE_RECIPIENT || ''
export const POLYMARKET_SIGNING_URL =
  import.meta.env.VITE_POLYMARKET_SIGNING_URL ||
  'https://bff-api.injective.network/api/v1/polymarket/sign'
export const CCTP_RELAYER =
  import.meta.env.VITE_CCTP_RELAYER ||
  'https://bff-api.injective.network/api/v1/bridge'
export const VITE_POLYMARKET_BUILDER_CODE = import.meta.env
  .VITE_POLYMARKET_BUILDER_CODE
export const TC_GLOBAL_DISCONNECT_ENABLED =
  import.meta.env.VITE_TC_GLOBAL_DISCONNECT_ENABLED === 'true'

const WS_PRICE_ORACLE_MAINNET_API_KEY =
  import.meta.env.VITE_WS_PRICE_ORACLE_API_KEY || ''
const WS_PRICE_ORACLE_TESTNET_API_KEY =
  import.meta.env.VITE_WS_PRICE_ORACLE_TESTNET_API_KEY || ''

export const WS_PRICE_ORACLE_API_KEY =
  IS_MAINNET
    ? WS_PRICE_ORACLE_MAINNET_API_KEY
    : WS_PRICE_ORACLE_TESTNET_API_KEY
